import "babel-polyfill";
import React from "react";
import { Route, withRouter, Switch } from "react-router-dom";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Tupas from "./static/tupas";
import Contact from "./static/Contact";
import FourOhFour from "./static/FourOhFour";
import FiveOhFive from "./static/FiveOhFive";
import AssignmentList from "./Dashboard/Dashboard";
import Plan from "./PaymentPlan/Plan";
import PlanDeal from "./PaymentPlan/PlanDeal";
import PlanInfo from "./PaymentPlan/PlanInfo";
import MoveDueDate from "./Duedate/MoveDueDate";
import Archive from "./Archive/Archive";
import PrivacyPolicy from "./static/PrivacyPolicy";
import CheckoutPage from "./Payment/Checkout";
import PaymentSuccess from "./Payment/Success";
import PaymentCancel from "./Payment/Cancel";
import Signicat from "./Signicat/Signicat";
import Thanks from "./Payment/Thanks";
import Fail from "./Payment/PaymentFail";
import AuthRoute from "./../auth/AuthRoute";

import fontawesome from "@fortawesome/fontawesome";
import faCircleNotch from "@fortawesome/fontawesome-free-solid/faCircleNotch";
import faBullseye from "@fortawesome/fontawesome-free-solid/faBullseye";
import faUserCircle from "@fortawesome/fontawesome-free-solid/faUserCircle";
import faBars from "@fortawesome/fontawesome-free-solid/faBars";
import faUserEdit from "@fortawesome/fontawesome-free-solid/faUserEdit";
import faPhone from "@fortawesome/fontawesome-free-solid/faPhone";
import faFileArchive from "@fortawesome/fontawesome-free-solid/faFileArchive";
import faFileAlt from "@fortawesome/fontawesome-free-solid/faFileAlt";
import faAddressBook from "@fortawesome/fontawesome-free-solid/faAddressBook";
import faFolderOpen from "@fortawesome/fontawesome-free-solid/faFolderOpen";
import faSignOutAlt from "@fortawesome/fontawesome-free-solid/faSignOutAlt";
import faAngleDown from "@fortawesome/fontawesome-free-solid/faAngleDown";
import faFilePdf from "@fortawesome/fontawesome-free-solid/faFilePdf";
import faArrowDown from "@fortawesome/fontawesome-free-solid/faArrowDown";
import Logout from "./Logout/Logout";
import NoOpenCases from "./static/NoOpenCases";

fontawesome.library.add(
  faCircleNotch,
  faBullseye,
  faUserCircle,
  faBars,
  faUserEdit,
  faPhone,
  faFileArchive,
  faFileAlt,
  faAddressBook,
  faFolderOpen,
  faSignOutAlt,
  faAngleDown,
  faFilePdf,
  faArrowDown
);

class App extends React.Component {

  render() {
    return (
      <div className="App">
        <Header />
        <div className={"container"}>
          <Switch>
            <Route exact path="/" component={Tupas} />
            <AuthRoute exact path="/dashboard" component={AssignmentList} />
            <AuthRoute exact path="/plan/:id" component={Plan} />
            <AuthRoute exact path="/plan-deal/:id" component={PlanDeal} />
            <AuthRoute exact path="/plan-info/:id" component={PlanInfo} />
            <AuthRoute exact path="/checkout" component={CheckoutPage} />
            <AuthRoute
              exact
              path="/move-due-date/:id"
              component={MoveDueDate}
            />
            <AuthRoute exact path="/archive" component={Archive} />
            <Route exact path="/logout" component={Logout} />
            <Route exact path="/privacy-policy" component={PrivacyPolicy} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/success" component={PaymentSuccess} />
            <Route exact path="/cancel" component={PaymentCancel} />
            <Route exact path="/signicat" component={Signicat} />
            <Route exact path="/500" component={FiveOhFive} />
            <Route exact path="/thanks" component={Thanks} />
            <Route exact path="/fail" component={Fail} />
            <Route exact path="/no-open-cases" component={NoOpenCases} />
            <Route component={FourOhFour} />
          </Switch>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: () => push("/static")
    },
    dispatch
  );

export default withRouter(connect(null, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App.js